import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { reportWebVitals } from "./lib/reportWebVitals";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Stream Core Web Vitals to GA4 so the admin can see real-user LCP / INP /
// CLS / FCP / TTFB by page in Google Analytics. Google's page-experience
// ranking signal is computed from real-user metrics, so this measurement is
// also what improves ranking when we optimise.
reportWebVitals();
